import { Vue, Component, Prop } from 'vue-property-decorator'
import ImageElement from '~/components/element/ImageElement'
import Img from '~/types/api/Img'

@Component
export default class ProductImage extends Vue {
  @Prop({ required: true, type: Object })
  readonly img!: Img

  @Prop({ type: String, default: '' })
  readonly title?: string

  @Prop({ type: String, default: '' })
  readonly alt!: string

  get code () {
    return JSON.stringify(this.img)
  }

  render () {
    if (this.code) {
      return (
        <div class="product-page-image">
          <div class="product-page-image__image">
            <ImageElement key={this.code} {...{
              props: {
                img: this.img,
                isMicrodata: true,
                title: this.title,
                alt: this.alt
              }
            }} />
          </div>

        </div>
      )
    }
  }
}
